import { useState } from 'react';
import { Settings, Search, ShieldCheck, Palette } from 'lucide-react';
import { AppShell } from '@/components/layout/AppShell';
import AdminWebsitePageDetail from '../detail/page';
import AdminSeoAnalyticsPage from '../seo-analytics-page/page';
import AdminTeamPage from '../../team/page';
import DesignPanel from './DesignPanel';
import { rxkModuleIcon, rxkModuleTitle, rxkNavGroups } from '../../nav';

const TABS = [
  { key: 'general', label: 'General', icon: Settings, Component: () => <AdminWebsitePageDetail pageSlug="settings" /> },
  { key: 'design', label: 'Design', icon: Palette, Component: DesignPanel },
  { key: 'seo', label: 'SEO & Analytics', icon: Search, Component: AdminSeoAnalyticsPage },
  { key: 'team', label: 'Team', icon: ShieldCheck, Component: AdminTeamPage },
];

export default function AdminSettingsPage() {
  const [active, setActive] = useState<string>(TABS[0].key);
  const activeTab = TABS.find((t) => t.key === active) ?? TABS[0];
  const ActiveComponent = activeTab.Component;

  return (
    <AppShell moduleTitle={rxkModuleTitle} moduleIcon={rxkModuleIcon} navGroups={rxkNavGroups}>
      <div className="space-y-5">
        <div className="flex items-center gap-1.5">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const isActive = tab.key === active;
            return (
              <button
                key={tab.key}
                onClick={() => setActive(tab.key)}
                className={`flex items-center gap-1.5 text-[12.5px] font-semibold px-3.5 py-2 rounded-full cursor-pointer transition-colors whitespace-nowrap ${
                  isActive ? 'bg-primary-800 text-white' : 'bg-surface-muted text-ink-faint hover:text-ink'
                }`}
              >
                <Icon className="w-3.5 h-3.5" /> {tab.label}
              </button>
            );
          })}
        </div>

        <div key={activeTab.key}>
          <ActiveComponent />
        </div>
      </div>
    </AppShell>
  );
}
